import { z } from 'zod';

export const TUNNEL_REQUIREMENT_ENFORCEMENTS = ['block', 'warn'] as const;

export const TunnelRequirementEnforcementSchema = z.enum(
  TUNNEL_REQUIREMENT_ENFORCEMENTS,
);

export type TunnelRequirementEnforcement = z.infer<
  typeof TunnelRequirementEnforcementSchema
>;

export const TUNNEL_UNSUPPORTED_REASONS = ['twingate', 'noNetwork'] as const;

export const TunnelUnsupportedReasonSchema = z.enum(TUNNEL_UNSUPPORTED_REASONS);

export type TunnelUnsupportedReason = z.infer<
  typeof TunnelUnsupportedReasonSchema
>;

export const NotRequiredTunnelRequirementSchema = z.object({
  kind: z.literal('notRequired'),
});

export const RequiredTunnelRequirementSchema = z.object({
  kind: z.literal('required'),
  enforcement: TunnelRequirementEnforcementSchema,
  tailscaleNetworkId: z.string().min(1),
  networkName: z.string().min(1),
  unscopedHosts: z.array(z.string()),
});

export const UnsupportedTunnelRequirementSchema = z.object({
  kind: z.literal('unsupported'),
  enforcement: TunnelRequirementEnforcementSchema,
  reason: TunnelUnsupportedReasonSchema,
});

export const TunnelRequirementSchema = z.discriminatedUnion('kind', [
  NotRequiredTunnelRequirementSchema,
  RequiredTunnelRequirementSchema,
  UnsupportedTunnelRequirementSchema,
]);

export type TunnelRequirement = z.infer<typeof TunnelRequirementSchema>;
export type RequiredTunnelRequirement = z.infer<
  typeof RequiredTunnelRequirementSchema
>;
export type UnsupportedTunnelRequirement = z.infer<
  typeof UnsupportedTunnelRequirementSchema
>;

export const TARGET_TUNNEL_REQUIREMENT_TARGET_TYPES = [
  'WEB_APPLICATION',
  'AI_APPLICATION',
  'EXTERNAL_NETWORK',
  'INTERNAL_NETWORK',
] as const;

export const TargetTunnelRequirementTargetTypeSchema = z.enum(
  TARGET_TUNNEL_REQUIREMENT_TARGET_TYPES,
);

export type TargetTunnelRequirementTargetType = z.infer<
  typeof TargetTunnelRequirementTargetTypeSchema
>;

export const GetTargetTunnelRequirementQuerySchema = z.object({
  targetType: TargetTunnelRequirementTargetTypeSchema,
  targetId: z.string().min(1),
});

export type GetTargetTunnelRequirementQuery = z.infer<
  typeof GetTargetTunnelRequirementQuerySchema
>;
